
import Vue, { PropType } from "vue";
import { Alert } from "@/models";

import ActiveAlertLongStayListHeader from "./ActiveAlertLongStayListHeader.vue";
import ActiveAlertLongStayListItem from "./ActiveAlertLongStayListItem.vue";

export default Vue.extend({
  name: "ActiveAlertLongStayList",

  props: {
    alerts: Array as PropType<Array<Alert>>,
  },

  components: {
    ActiveAlertLongStayListHeader,
    ActiveAlertLongStayListItem,
  },
});
